module.exports = __webpack_public_path__ + "img/image_case_5.75ecc8f1.png";